import script from "./ConfluenceIntervals.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfluenceIntervals.vue?vue&type=script&setup=true&lang=js"

import "./ConfluenceIntervals.vue?vue&type=style&index=0&id=5ad51323&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad51323"]])

export default __exports__